export class Credit {
  id: number;
  spend_account_id: number;
  budget_id: number | null;
  amount: number;
  effective_date: string | null;
  source_type: string;
  reason: string | null;

  constructor(data: any) {
    this.id = data.id;
    this.spend_account_id = data.spend_account_id;
    this.budget_id = data.budget_id ?? null;
    this.amount = Number(data.amount ?? 0);
    this.effective_date = data.effective_date ?? null;
    this.source_type = data.source_type ?? "MANUAL";
    this.reason = data.reason ?? null;
  }
}
